import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs';
import {ConfigService} from './config.service';

export interface Organization {
  id?: number;
  name: string;
  logo?: { url: string };
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  accessToken?: string;
  organizationId?: string;

  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService,
  ) {
  }

  setAccessJwt(accessToken: string | null | undefined) {
    if (!accessToken) return;
    sessionStorage.setItem('accessToken', accessToken);
    this.accessToken = accessToken;
    this.decodeAccessToken();
  }

  private decodeAccessToken() {
    const payload = this.accessToken?.split('.')[1]!;
    const decoded = JSON.parse(atob(payload));
    this.organizationId = decoded.org;
  }

  fetchOrganization() {
    return this.httpClient.get<any>(`${this.configService.environment.strapiApiUrl}/organizations`, {
      params: {
        "filters[org][$eq]": this.organizationId!,
        populate: 'logo',
        normalize: 1
      },
    }).pipe(
      map((response: any) => {
        return response.data[0];
      }),
    )
  }


}
